import {inject, Injectable} from "@angular/core";
import {getApiUrl} from "../core/helpers/env.helper";
import {catchError, map, Observable, of, switchMap} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {GroupedSearchResults, SearchApiResponse, SearchResultItem} from "../core/model/search";
import {exponentialBackoffRetry} from '../core/operators/retry.operator';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  private readonly httpClient = inject(HttpClient);

  search(term: string, page = 1, limit = 10): Observable<SearchApiResponse> {
    return getApiUrl('search').pipe(
      map(url => `${url}/search?query=${term}&page=${page}&limit=${limit}`),
      switchMap(url => this.httpClient.get<SearchApiResponse>(url).pipe(
        exponentialBackoffRetry([500]),
        map(response => ({
          ...response,
          groupedResults: this.groupResults(response.results)
        }))
      )),
      catchError(err => {
        console.error(err);
        return of({
          error: err.message,
          answer: '',
          context: [],
          results: [],
          groupedResults: {}
        });
      }),
    );
  }

  private groupResults(results: SearchResultItem[]): GroupedSearchResults {
    return results.reduce((grouped, item) => {
      // Create a key based on type and serialNumber (if available)
      const type = item.data?.type ?? 'unknown';
      const serialNumber = item.data?.serialNumber ?? 'unspecified';
      const key = `${type}_${serialNumber}`;

      // Initialize the array for this key if it doesn't exist
      if (!grouped[key]) {
        grouped[key] = [];
      }

      // Add the item to the appropriate group
      grouped[key].push(item);

      return grouped;
    }, {} as GroupedSearchResults);
  }

}
